import React from "react";
import './EmailOverlay.css';
import * as actions from '../Actions';
// import { render } from "react-dom";

export default function EmailOverlay({ eleRef }) {
    return (
        <div>
            <div className="email-overlay">
                <div className="email-popup">
                    <div className="email-header">
                        <span className="B14_42">SHARE THIS BY EMAIL</span>
                        <span className="icon closeButton" data-icon-font="C" onClick={(e) => actions.closeEmailPopup(e)}></span>
                    </div>
                    <div className="write-comment-container email-container shareByEmail">
                        <div className="email-box-id">
                            <span className="R15_42 to-label">TO</span>
                            <input className="R12_9e" type="text" id="email_to" placeholder="enter email addresses separated by (,)" />
                            <p id="EmailIdErrMs" className="spanErrorMsg" style={{ display: 'none' }}>Please Enter a valid Email Id</p>
                        </div>
                        <div className="email-box-content">
                            <span className="R15_42 msg-label">MESSAGE</span>
                            <div className="message_here">
                                <textarea className="R12_9e type-msg" defaultValue={eleRef.state.emailbody}>
                                </textarea>
                            </div>
                            <span className="read-only-text"></span>
                            <span className="read-only-regards">Best Regards,&#10;Team FirstCry</span>
                        </div>
                        <p id="MsgErrMs" className="spanErrorMsg" style={{ display: 'none' }}>Please Enter message</p>
                        <div className="email-box-send right" id="sendemail">
                            <div id="sendEmail" className="askB_1 button-lft" onClick={(e) => actions.sendFetusEmail()}>
                                <p title="Send Email">
                                    <span className="fetusButtons M15_white" id="sendemail">SEND EMAIL</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        );
}



// WEBPACK FOOTER //
// src/shared/tools/common/EmailOverlay.js